export const TASK_PRIORITY_OPTIONS = [
  { label: 'High',   value: 'high' },
  { label: 'Normal', value: 'normal' },
  { label: 'Low',    value: 'low' },
];
